import { z } from "zod";

/** Editable hero pill, e.g. "Shipping envault". */
export const nowPill = z.object({ label: z.string().min(1).max(60) });
export type NowPill = z.infer<typeof nowPill>;

/**
 * Singleton site settings — all the copy on the desk that isn't a content list.
 * Stored as one row keyed "site".
 */
export const siteSettings = z.object({
  eyebrow: z.string().max(120),
  headline: z.string().max(200),
  headlineAccent: z.string().max(120),
  heroSub: z.string().max(600),
  deskNote: z.string().max(160),
  nowPills: z.array(nowPill).max(6),
  portraitUrl: z.string().max(500),
  portraitCaption: z.string().max(120),
  footerNote: z.string().max(160),
  updatedAt: z.string().datetime({ offset: true }),
});
export type SiteSettings = z.infer<typeof siteSettings>;

export const siteSettingsUpdate = siteSettings
  .omit({ updatedAt: true })
  .partial();
export type SiteSettingsUpdate = z.infer<typeof siteSettingsUpdate>;
